var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgLog = function SvgLog(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48",
    fill: "currentColor"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38 8H10a4 4 0 00-4 4v24a4 4 0 004 4h28a4 4 0 004-4V12a4 4 0 00-4-4z",
    stroke: "#089BEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 16h20m-20 8h20m-20 8h20",
    stroke: "#30A9EE"
  }))));
};
export default SvgLog;